<template>
  <div class="w-full py-[20vh] pt-[14vh]">
    <div class="w-[90%] mx-auto max-w-xl">
      <h1
        class="capitalize font-belgiano text-realBlack md:text-[60px] text-4xl font-bold md:leading-[70px]"
      >
        Contact Us
      </h1>

      <div
        class="w-full flex flex-col md:flex-row gap-16 mt-10 items-start justify-between"
      >
        <div class="md:w-1/2 w-full">
          <div class="w-full">
            <h4 class="text-3xl font-inter font-medium">Get in Touch</h4>
            <p class="font-verdana font-medium mt-2">
              Email:
              <a class="inline-block ml-1" href="mailto:info@qoraymobility.com"
                >info@qoraymobility.com</a
              >
            </p>
            <p class="font-verdana font-medium mt-2">
              Phone:
              <a class="inline-block ml-1" href="tel:+2348133059384"
                >+234 813 305 9384</a
              >
            </p>
          </div>
          <div class="w-full mt-14">
            <h4 class="text-3xl font-inter font-medium">Visit Us</h4>
            <p class="font-verdana font-medium mt-2">
              20 Marina, Lagos, Nigeria.
            </p>
          </div>
          <div class="w-full mt-14">
            <h4 class="text-3xl font-inter font-medium">Connect with Us</h4>
            <p class="font-verdana font-medium mt-2 md:w-2/3">
              Follow us on social media to stay updated on our latest
              innovations and community initiatives.
            </p>
            <div class="flex items-center w-full gap-6 mt-12 mb-16 text-black">
              <a
                href="https://www.instagram.com/qoraymobility/"
                target="_blank"
              >
                <Instagram />
              </a>
              <!-- <a href="" target="_blank">
          <img src="@/assets/svgs/threads.svg" alt="" />
        </a> -->
              <!-- <a href="" target="_blank">
          <img src="@/assets/svgs/linkedin.svg" alt="" />
        </a> -->
              <a href="https://x.com/qoraymobility" target="_blank">
                <!-- <img src="@/assets/svgs/twitter.svg" alt="" /> -->
                <Twitter />
              </a>
              <a href="https://www.youtube.com/@QorayMobility" target="_blank">
                <!-- <img src="@/assets/svgs/youtube.svg" alt="" /> -->
                <Youtube />
              </a>
              <!-- <a href="" target="_blank">
          <img src="@/assets/svgs/facebook.svg" alt="" />
        </a> -->
            </div>
          </div>
        </div>
        <div
          class="md:w-1/2 w-full bg-realBlack text-white rounded-md md:p-8 p-6"
          id="formm"
        >
          <h4 class="text-3xl font-inter font-medium">Contact Form</h4>
          <div class="w-full mt-6">
            <div class="w-full">
              <label class="text-sm opacity-75">Name</label>
              <input
                class="w-full bg-[#303030] placeholder:text-[#9CA3AF] mt-1 py-4 px-5 rounded-lg"
                type="text"
                placeholder="Name"
                v-model="name"
              />
              <p class="mt-1 !text-red text-xs">{{ errs.name }}</p>
            </div>
            <div class="w-full mt-4">
              <label class="text-sm opacity-75">Phone Number</label>
              <input
                class="w-full bg-[#303030] placeholder:text-[#9CA3AF] mt-1 py-4 px-5 rounded-lg"
                type="text"
                v-model="phone_number"
                placeholder="Phone number"
              />
              <p class="mt-1 !text-red text-xs">{{ errs.phone_number }}</p>
            </div>
            <div class="w-full mt-4">
              <label class="text-sm opacity-75">Email Address</label>
              <input
                class="w-full bg-[#303030] placeholder:text-[#9CA3AF] mt-1 py-4 px-5 rounded-lg"
                type="email"
                v-model="email"
                placeholder="Email address"
              />
              <p class="mt-1 !text-red text-xs">{{ errs.email }}</p>
            </div>
            <div class="w-full mt-4">
              <label class="text-sm opacity-75">Organization</label>
              <input
                class="w-full bg-[#303030] placeholder:text-[#9CA3AF] mt-1 py-4 px-5 rounded-lg"
                type="text"
                v-model="organization"
                placeholder="Organization (Optional)"
              />
              <p class="mt-1 !text-red text-xs">{{ errs.organization }}</p>
            </div>
            <div class="w-full mt-4">
              <label class="text-sm opacity-75">Role</label>
              <input
                class="w-full bg-[#303030] placeholder:text-[#9CA3AF] mt-1 py-4 px-5 rounded-lg"
                type="text"
                v-model="role"
                placeholder="Role (Optional)"
              />
              <p class="mt-1 !text-red text-xs">{{ errs.role }}</p>
            </div>
            <div class="w-full mt-4">
              <label class="text-sm opacity-75">Service of Interest</label>
              <select
                v-model="service"
                class="w-full bg-[#303030] mt-1 py-4 px-5 rounded-lg"
              >
                <option value="" disabled selected>Service of Interest</option>
                <option value="Financing">Financing</option>
                <option value="Switch">Switch</option>
                <option value="Energy networks">Energy networks</option>
                <option value="Manufacturing, Assembly and Sales">
                  Manufacturing, Assembly and Sales
                </option>
                <option value="Mobility as a Service">
                  Mobility as a Service
                </option>
                <option value="Tour with Qoray">Tour with Qoray</option>
              </select>
              <p class="mt-1 !text-red text-xs">{{ errs.service }}</p>
            </div>
            <div class="w-full mt-4">
              <label class="text-sm opacity-75">Request Description</label>
              <textarea
                name=""
                id=""
                class="w-full resize-none bg-[#303030] placeholder:text-[#9CA3AF] mt-1 py-4 px-5 rounded-lg"
                cols="30"
                rows="4"
                v-model="description"
                placeholder="Request description (Optional)"
              ></textarea>
              <p class="mt-1 !text-red text-xs">{{ errs.description }}</p>
            </div>
            <button class="white-btn w-full mt-4" @click.prevent="submit">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Instagram from "@/components/Instagram.vue";
import Twitter from "@/components/Twitter.vue";
import Youtube from "@/components/Youtube.vue";
export default {
  components: {
    Instagram,
    Twitter,
    Youtube,
  },
  data() {
    return {
      name: "",
      phone_number: "",
      email: "",
      organization: "",
      role: "",
      service: "",
      description: "",
      errs: {
        name: "",
        phone_number: "",
        email: "",
        organization: "",
        role: "",
        service: "",
        description: "",
      },
    };
  },
  computed: {
    today() {
      // Get today's date
      const today = new Date();
      today.setDate(today.getDate() + 1);
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const dd = String(today.getDate()).padStart(2, "0");

      // Format the date as YYYY-MM-DD
      const formattedToday = `${yyyy}-${mm}-${dd}`;
      return formattedToday;
    },
    payload() {
      return {
        name: this.name,
        phone_number: this.phone_number,
        email: this.email,
        organization: this.organization,
        role: this.role,
        service: this.service,
        description: this.description,
      };
    },
  },
  methods: {
    success() {
      this.$store.dispatch("modalSuccess", {
        title: "Request Submitted",
        top: `Your submission has been received.`,
        bottom: "A sales rep will reach out to you in 72 hours",
      });
    },
    validateForm() {
      this.errs = {
        name: "",
        phone_number: "",
        email: "",
        organization: "",
        role: "",
        service: "",
        description: "",
      };
      var rege = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      if (this.name.length < 2) {
        this.errs.name = "Name is too short";
        return false;
      } else if (this.phone_number.length < 10) {
        this.errs.phone_number = "Invalid Phone Number";
        return false;
      } else if (!this.email.length || !this.email.match(rege)) {
        this.errs.email = "Invalid Email";
        return false;
      } else if (!this.service.length) {
        this.errs.service = "Field is required";
        return false;
      } else {
        return true;
      }
    },
    async submit() {
      if (this.validateForm() === true) {
        try {
          const res = await fetch(process.env.VUE_APP_API_URL + "/contact", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...this.payload, platform: "qoray-mobility" }),
          });
          if (!res.ok) throw new Error("Request failed");
          this.success();
        } catch (error) {
          alert("something went wrong, please try again");
          console.log(error);
        }
      } else {
        window.scrollTo({
          top: document.getElementById("formm").offsetTop,
          behavior: "smooth", // optional, for smooth scrolling
        });
      }
    },
  },
};
</script>

<style>
</style>